import { API, CustomAxiosConfig } from './types'

class Internal {
  api: API

  constructor(api: API) {
    this.api = api
  }

  client = async (config: CustomAxiosConfig = {}): Promise<object> => {
    const response = await this.api.get('/internal/client-api-schema', config)
    return response.data
  }

  supplyChain = async (config: CustomAxiosConfig = {}): Promise<object> => {
    const response = await this.api.get('/internal/supply-chain-api-schema', config)
    return response.data
  }
}

export class Docs {
  api: API
  internal: Internal

  constructor(api: API) {
    this.api = api
    this.internal = new Internal(api)
  }

  auth = async (config: CustomAxiosConfig = {}): Promise<object> => {
    const response = await this.api.get('/auth-api-schema', config)
    return response.data
  }

  client = async (config: CustomAxiosConfig = {}): Promise<object> => {
    const response = await this.api.get('/client-api-schema', config)
    return response.data
  }
}

